import { HeaderPage } from "../../../components/header-page/HeaderPage";
import { BreadcrumbItem } from "../../../components/common/breadcrumbs/Breadcrumbs";

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Productos", href: "/dashboard/products" },
  { label: "Categorías de Productos" },
];

export const CategoryHeader = () => {
  return (
    <HeaderPage
      title="Categorías de Productos"
      breadcrumbItems={breadcrumbItems}
    />
  );
};
